import { render, staticRenderFns } from "./DeleteStudent.vue?vue&type=template&id=b77b9b54&"
import script from "./DeleteStudent.vue?vue&type=script&lang=js&"
export * from "./DeleteStudent.vue?vue&type=script&lang=js&"
import style0 from "./DeleteStudent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports